import { useDispatch, useSelector } from "react-redux";

import * as constants from "@/constants";
import { RootState } from "@/reducers/types";
import { PlotPlanState } from "@/sx-layout/components/settings/plotPlanSetting/reducers/plotPlan";
import { usePlotPlanApi } from "@/sx-layout/hooks/usePlotPlanApi";

export const usePlotPlans = () => {
  const dispatch = useDispatch();
  const plotPlanApi = usePlotPlanApi();

  const { plotPlans, fetching } = useSelector<RootState, PlotPlanState>((state) => state.plotPlan);

  const refreshPlotPlans = async (): Promise<void> => {
    const response = await plotPlanApi.fetchPlotPlans();

    dispatch({
      type: constants.PLOT_PLAN_END_FETCH_PLOT_PLANS,
      payload: response?.plot_plans ?? [],
    });
  };

  return { plotPlans, fetching, refreshPlotPlans } as const;
};
